export type ErrorCategory = 'yaml_error' | 'access_error' | 'connection_error' | 'infrastructure_error' | 'general_error';

export function classifyContractError(
  errorMessage: string | null | undefined,
  taskType: string | null | undefined
): ErrorCategory {
  if ( taskType === 'ACCESSCONTROL' ) {
    return 'access_error';
  }

  const msg = ( errorMessage ?? '' ).toLowerCase();

  // Pulumi-driven provision failures take precedence — their raw logs often
  // contain words like "connection" or "syntax" that would otherwise misroute
  // to connection_error or yaml_error and surface unhelpful generic tips.
  if ( /pulumi (up|destroy|preview) failed/.test( msg ) ) {
    return 'infrastructure_error';
  }

  if ( /yaml|parse|syntax|invalid|missing field|required/.test( msg ) ) {
    return 'yaml_error';
  }

  if ( /access|permission|denied|unauthorized|forbidden|authentication|credentials|secret/.test( msg ) ) {
    return 'access_error';
  }

  if ( /connection|host|port|database|timeout|refused|unreachable|network/.test( msg ) ) {
    return 'connection_error';
  }

  return 'general_error';
}
